<template>
   <div>
      <a-card class="card" title="" :bordered="true">
          <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="48">
                  <a-col :md="6" :sm="24" style="float:left">
                    <a-form-item label="物料名称">
                      <a-select
                        v-model="materielId"
                        showSearch
                        @change="changeMateriel"
                        placeholder="请选择"
                        default-value="0"
                      >

                        <a-select-option v-for="(item, index) in materielSelect" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>


                  <a-col :md="6" :sm="24" style="float:left">
                    <a-form-item label="设置类型">
                      <a-select
                        v-model="type"
                        defaultValue="1"
                        >
                        <a-select-option  key="1" value="1">袋装净重误差</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>



                  <a-col :md="6" :sm="24" style="float:right">
                      <a-form-item label="设置方式">
                      <a-radio-group defaultValue="1" v-model="model" @change="changeModel"
                      >

                        <a-radio value="1">百分比</a-radio>
                        <a-radio value="2">实际吨位</a-radio>
                      </a-radio-group>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
            </div>

            <!-- 上部功能导航 -->
        <div class="table-operator">
          <a-button type="primary" icon="plus" @click="newRule()">新建</a-button>
        </div>
            
        <a-table
          :pagination="true"
          :columns="columns"
          :bordered="config.globlaBordered"
          :dataSource="data"
        >
        <template slot="lowerTon" slot-scope="text, record, index">
            <a-input-number
              v-model="record.lowerTon"
              :min="0"
              style="width: 100%;text-align:center"
            />
        </template>

        <template slot="xValue" slot-scope="text, record,index">
            <= X <
        </template>

        <template slot="upperTon" slot-scope="text, record, index">
            <a-input-number
              v-model="record.upperTon"
              :min="0"
              style="width: 100%;text-align:center"
            />
        </template>

    <template slot="lowerOffset" slot-scope="text, record, index" >
          <a-input-number v-if=" record.model !='2' && isShow || record.model=='1' "
            v-model="record.lowerOffset"
            :min="0"
            :max="100"
            :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')"
            style="width: 100%"
          />
      <a-input-number
        v-if="record.model !='1' && !isShow || record.model=='2' "
        v-model="record.lowerOffset"
        :min="0"
        :max="100"
        :formatter="value => `${value}`"
        :parser="value => value.replace('%', '')"
        style="width: 100%"
      />
      </template>
    
      <template slot="upperOffset" slot-scope="text, record, index">
          <a-input-number
            v-if="record.model !='2' && isShow  || record.model=='1' "
            v-model="record.upperOffset"
            :min="0"
            :max="100"
            :formatter="value => `${value}%`"
            :parser="value => value.replace('%', '')"
            style="width: 100%"
        />
        <a-input-number
          v-if="record.model !='1' && !isShow || record.model=='2'  "
          v-model="record.upperOffset"
          :min="0"
          :max="100"
          :formatter="value => `${value}`"
          :parser="value => value.replace('%', '')"
          style="width: 100%"
        />
      </template>

      <template slot="priority" slot-scope="text, record, index">
          <a-input-number
            v-model="record.priority"
            :min="0"
            style="width: 100%;text-align:center"
          />
      </template>


          <template slot="materielId" slot-scope="text, record, index">
            <a-input-number disabled="ture"
              v-model="record.materielId"
              :min="0"
              style="width: 100%;text-align:center"
            />
          </template>

          <template slot="materielName" slot-scope="text, record, index">
            <a-input-number disabled="ture"
                            v-model="record.materielName"
                            :min="0"
                            style="width: 100%;text-align:center"
            />
          </template>

        <template slot="action" slot-scope="text, record">
            <span>
              <!--<a-popconfirm title="是否要删除此行？" @confirm="remove(record.key)">-->
              <a-popconfirm title="是否要删除此行？" @confirm="remove(record)">
                <a>删除</a>
              </a-popconfirm>
            </span>
        </template>
      </a-table>
    </a-card>

      <a-card :bordered="false" >
        <a-button type="primary" @click="doSubmit"  style="float: right">保存</a-button>
      </a-card>
    </div>
  </template>

  <script>
  import { STable } from '@/components'
  import { weighingLimitList, weighingLimitSave ,materielList,materWeighingLimitList,materWeighingLimitDelete} from '@/api/basic'
  import Bus from '@/layouts/bus'

  export default {
    name: 'ReservationList',
    components: {
      STable
    },
    data () {
      return {
        isShow:true,
        description: '',
        form: this.$form.createForm(this),
        loading: true,
        data: [],
        type:'1',
        model:'1',
        selectMater: {},
        queryParam: {},
        // bordered: true,
        // 所属菜单下拉
        materielSelect: null,
        materielId: '请选择',
        materielName: '',
        columns: [
          {
            title: '吨位下限',
            dataIndex: 'lowerTon',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'lowerTon' }
          },
          {
            title: '差值',
            dataIndex: 'xValue',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'xValue' }
          },
          {
            title: '吨位上限',
            dataIndex: 'upperTon',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'upperTon' },
          },
          {
            title: '偏差下限',
            dataIndex: 'lowerOffset',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'lowerOffset' }
          },
          {
            title: '偏差上限',
            dataIndex: 'upperOffset',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'upperOffset' }
          },
          {
            title: '优先级',
            dataIndex: 'priority',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'priority' }
          },
          {
            title: '物料Id',
            dataIndex: 'materielId',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'materielId' }
          },
          {
            title: '物料',
            dataIndex: 'materielName',
            width: '80px',
            align: 'center',
            scopedSlots: { customRender: 'materielName' }
          },
          {
            title: '操作',
            width: '50px',
            align: 'center',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          },
        ],
      }
    },

    created () {
      this.loadData()
      this.loadSelect()

    },

    methods: {
      loadData () {
        let that = this
        weighingLimitList({})
          .then(res => {
            if (res.code === '0') {
              that.data = res.data
              that.data.map((item,index)=>{item.key = index})
              if (that.data.length > 0){
               // that.model = that.data[0].model
              }

            }
          }).catch((e) => {
            console.log(e)
        })
      },
      loadSelect () { // 从后台拉去下拉列表数据

        new Promise(resolve => {
          const data = materielList({ }).then(res => { return res.data })
          resolve(data)
        }).then(res => {
          this.materielSelect = res

        })

      },
      changeModel(e){
        if(e.target.value == 1){
            this.model = '1'
            this.isShow = true
        }else{
          this.model = '2'
          this.isShow = false
        }
        //this.loadData();
       // this.materielId='请选择';
      },
      changeMateriel(e) {
        for(var i=0;i<this.materielSelect.length;i++){
            var selectMater =this.materielSelect[i]
          if(selectMater.id == e){
            this.materielName =  selectMater.name
            break
          }
        }
          let materielId=e;
          this.materielId =materielId
          let that=this
           materWeighingLimitList({'materId':materielId})
             .then(res => {
               that.data = res.data
               if (res.code === '0') {
                 if (that.data[0].materielId){
                 that.data.map((item, index) => {
                   item.key = index
                 })
                 if (that.data.length > 0) {
                   //that.model = that.data[0].model
                   if(that.model === '1'){
                     this.isShow = true
                   }else{
                     this.isShow = false
                   }
                 }
               }else{
                   for (let i = 0; i < this.data.length; i++) {
                     let item = this.data[i]
                     // let materielId = item.materielId
                     item.materielId = e;
                     //item.materielName = this.materielName;
                   }
                 }
             }
             }).catch((e) => {
             console.log(e)
           })
      },

      newRule () {
          if(isNaN(this.materielId)){
            this.$message.warning('请选择物料',3)
            return
          }
        let length = this.data.length
        if (length === 4){
          this.$message.warning('最多添加4条规则',3)
          return
        }
        var  modelValue = this.model
        this.data.push({
          key: length === 0 ? '1' : (parseInt(this.data[length - 1].key) + 1).toString(),
          lowerTon: '',
          upperTon: '',
          lowerOffset: '',
          upperOffset: '',
          type: '',
          model: modelValue,
          priority: '',
          materielId : this.materielId,
          materielName : this.materielName
        })
      },

      remove(record) {
          var key=record.key
        const newData = this.data.filter(item => item.key !== key)
        this.data = newData
        this.handleDel(record);
      },

      validate () {
         if (this.data.length === 0){
            this.$message.warning('请添加规则',3)
            return false
         }

         for (let i=0; i<this.data.length; i++){
            let item = this.data[i]
            if (item.lowerTon ===undefined ||
                item.upperTon ===undefined ||
                item.lowerOffset ===undefined ||
                item.upperOffset ===undefined ||
                item.model ===undefined
            ){
              this.$message.warning('请完善规则信息',3)
              return false
            }
           // item.model = this.model
            item.type = this.type
            for (var prop in item) {
              if (prop === "key" ||
                  prop === "createTime"  ||
                  prop === "updateTime") {
                delete item[prop];
              }
            }
         }
         return true
      },

      // 最终全页面提交
      doSubmit () {
       /* for (let i=0; i<this.data.length; i++) {
          let item = this.data[i]
          let materielId=item.materielId
          if(!materielId){
            this.$message.warning('请选择物料信息',3)
            return false
          }
        }*/
        if (!this.validate()){
          return
        }
        const that = this
        Bus.$emit('showSpinning', true, "提交中...")
        weighingLimitSave(JSON.stringify(this.data))
        .then(res => {
          if (res.code === '0') {
            that.loadData()
            this.materielId='请选择'
            Bus.$emit('showSpinning', false)
          }
        }).catch((e) => {
          console.log(e)
        }).finally(() => {
          Bus.$emit('showSpinning', false)
        })
      },
      handleDel(record) {
        var nthis = this
            nthis.confirmLoading = true
            return materWeighingLimitDelete(Object.assign(record, nthis.queryParam))
              .then(res => {
                nthis.$emit('ok')
              })
              .catch(e => {
                console.log(e)
              })
              .finally(() => {
                nthis.confirmLoading = false
              })
          },
    },
    watch: {

    }

  }
  </script>
  